import { restRequest } from "vrcore-dashboard/dist/utilities";

export const GET_REPORT_TITLES = restRequest(
    "VRCORE_SUBMITTED_REPORTS_V2.GET_REPORT_TITLES"
);
export const GET_USER_DATA = restRequest(
    "VRCORE_SUBMITTED_REPORTS_V2.GET_USER_DATA"
);
export const GET_JOB_YEARS = restRequest(
    "VRCORE_SUBMITTED_REPORTS_V2.GET_JOB_YEARS"
);
export const GET_REPORTS = restRequest(
    "VRCORE_SUBMITTED_REPORTS_V2.GET_REPORTS"
);
export const GET_JOB_PACKS = restRequest(
    "VRCORE_SUBMITTED_REPORTS_V2.GET_JOB_PACKS"
);
export const GET_JOB_PENDING = restRequest(
    "VRCORE_SUBMITTED_REPORTS_V2.GET_JOB_PENDING"
);
export const GET_JOB_ARCHIVED = restRequest(
    "VRCORE_SUBMITTED_REPORTS_V2.GET_JOB_ARCHIVED"
);
export const SET_SORT_TABLE_AS = "SET_SORT_TABLE_AS";
export const SET_SORT_TABLE_TYPE = "SET_SORT_TABLE_TYPE";
export const SET_SORT_TABLE_KEY = "SET_SORT_TABLE_KEY";
export const SET_FILTER_DEPARTMENT =
    "VRCORE_SUBMITTED_REPORTS_V2.SET_FILTER_DEPARTMENT";
export const SET_FILTER_AREA = "VRCORE_SUBMITTED_REPORTS_V2.SET_FILTER_AREA";
export const SET_FILTER_REPORT_TYPE =
    "VCORE_SUBMITTED_REPORTS_V2.SET_REPORT_TYPE";
export const SET_FILTER_DEPARTMENT_NAME =
    "VCORE_SUBMITTED_REPORTS_V2.SET_FILTER_DEPARTMENT_NAME";
export const SET_FILTER_AREA_NAME =
    "VCORE_SUBMITTED_REPORTS_V2.SET_FILTER_AREA_NAME";
export const SET_FILTER_USER_UID =
    "VRCORE_SUBMITTED_REPORTS_V2.SET_FILTER_USER_UID";
export const SET_SEARCH_DATE_FROM =
    "VRCORE_SUBMITTED_REPORTS_V2.SET_SEARCH_DATE_FROM";
export const SET_SEARCH_DATE_TO =
    "VRCORE_SUBMITTED_REPORTS_V2.SET_SEARCH_DATE_TO";
export const SET_REPORT_FILTER_STATE =
    "VRCORE_SUBMITTED_REPORTS_V2.SET_REPORT_FILTER_STATE";
export const SET_ROWS_PER_PAGE =
    "VRCORE_SUBMITTED_REPORTS_V2.SET_ROWS_PER_PAGE";
export const SET_PAGE = "VRCORE_SUBMITTED_REPORTS_V2.SET_PAGE";
export const SET_REPORT_STATUS = restRequest(
    "VRCORE_SUBMITTED_REPORTS_V2.SET_REPORT_STATUS"
);
export const SET_SELECTED_ROW = "VRCORE_SUBMITTED_REPORTS_V2.SET_SELECTED_ROW";
export const SET_REPORT_EDIT_STATUS = restRequest(
    "VRCORE_SUBMITTED_REPORTS_V2.SET_REPORT_EDIT_STATUS"
);
export const SET_STATUS_CHANGE_MODAL_INFO =
    "VRCORE_SUBMITTED_REPORTS_V2.SET_STATUS_CHANGE_MODAL_INFO";
export const DELETE_REPORT = restRequest(
    "VRCORE_SUBMITTED_REPORTS_V2.DELETE_REPORT"
);
export const SET_DELETE_STATUS =
    "VRCORE_SUBMITTED_REPORTS_V2.SET_DELETE_STATUS";
export const SET_FILTER_JOB_ID =
    "VRCORE_SUBMITTED_REPORTS_V2.SET_FILTER_JOB_ID";
export const SET_FILTER_YEAR = "VRCORE_SUBMITTED_REPORTS_V2.SET_FILTER_YEAR";
export const SET_FILTER_MONTH = "VRCORE_SUBMITTED_REPORTS_V2.SET_FILTER_MONTH";
export const GET_JOBPACKS = restRequest(
    "VRCORE_SUBMITTED_REPORTS_V2.GET_JOBPACKS"
);
export const SET_REPORT = restRequest("VRCORE_SUBMITTED_REPORTS_V2.SET_REPORT");
export const PARTICULAR_REPORTS = restRequest(
    "VRCORE_SUBMITTED_REPORTS_V2.PARTICULAR_REPORTS"
);
export const SET_DAY = restRequest("VRCORE_SUBMITTED_REPORTS_V2.SET_DAY");
export const CLIENT_NAME = restRequest("VRCORE_SUBMITTED_REPORTS_V2.CLIENT_NAME");